<template>
  <div class="vx-input-group flex mb-0">
    <div class="vx-input-group-default flex-grow">
      <div>
        <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
          <div class="vs-con-input">
            <!-- v-model="fieldModel[field.hash]" -->
            <the-mask :masked="saveMask"
              :type="type"
              :placeholder="placeholder" 
              autocomplete="new-password"
              
              :disabled="isDisabled"
              @focusout.native="$emit('focusout', $event)"
              :mask="mask" 
              :value="value"
              @input="onInput($event)"
              class="vs-inputx vs-input--input normal need-style-placeholder"
              :maxlength="maxlength"
              style="border: 1px solid rgba(0, 0, 0, 0.2);" />
            <!-- <span class="input-span-placeholder vs-input--placeholder normal">{{field.placeholder}}</span> -->
          </div>
          <span></span>
        </div>
      </div>
    </div>
  </div>
  <!-- :name="field.name" -->
</template>

<script>
export default {
  props: {
    mask: {
      type: String,
      default: '##########'
    },
    type: {
      type: String,
      default: 'text'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 524288
    },
    placeholder: {
      type: String,
      default: ''
    },
    cursor: {
      type: String,
      default: 'default'
    },
    saveMask: {
      type: Boolean,
      default: false
    }
  },
  watch: {

  },
  data() {
    return {
      text: ''
    };
  },
  methods: {
    onInput(event) {
      this.$emit('input', event);
    },
    handleFocusOut() {
      this.$emit("focusout");
    },
    handleClick() {
      this.$emit("onTextFieldClick");
    }
  }
};
</script>

<style scoped>
/* Add component-specific styles here */
</style>
